(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pixelrebels-stamp"] && !Shopify.designMode) return;
  try {
    (function(){
  'use strict';
  if(window.PixelRebelsStampV1){window.PixelRebelsStampV1.init();return;}
  var states=new Map(),reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
  function paused(el,s){return s.manual||reduce.matches||el.dataset.motion==='off';}
  function sync(el,s){
    el.classList.toggle('prs1-paused',paused(el,s));
    el.classList.toggle('prs1-hidden',document.hidden);
    if(paused(el,s)){el.classList.remove('prs1-reveal','prs1-interact');}
    s.button.setAttribute('aria-pressed',String(s.manual));
    s.button.setAttribute('aria-label',s.manual?el.dataset.resume:el.dataset.pause);
    s.button.title=s.manual?el.dataset.resume:el.dataset.pause;
    
  }
  function reveal(el,s){
    if(paused(el,s)||document.hidden)return;
    clearTimeout(s.timer);el.classList.remove('prs1-reveal','prs1-interact');

    void el.offsetWidth;el.classList.add('prs1-reveal');
    s.timer=setTimeout(function(){el.classList.remove('prs1-reveal');},1400);
  }
  var observer='IntersectionObserver' in window?new IntersectionObserver(function(entries){
    entries.forEach(function(entry){var el=entry.target,s=states.get(el);if(!s)return;
      el.classList.toggle('prs1-visible',entry.isIntersecting);
      if(entry.isIntersecting&&!s.seen){s.seen=true;reveal(el,s);}
    });
  },{threshold:.25}):null;
  function init(root){
    states.forEach(function(s,el){if(!el.isConnected){if(observer)observer.unobserve(el);clearTimeout(s.timer);clearTimeout(s.hoverTimer);states.delete(el);}});
    var scope=root||document,nodes=Array.from(scope.querySelectorAll('.prs1'));
    if(scope.matches&&scope.matches('.prs1'))nodes.unshift(scope);
    nodes.forEach(function(el){
      if(states.has(el))return;
      var link=el.querySelector('.prs1-link'),button=el.querySelector('.prs1-toggle');
      if(!link||!button)return;
      var s={button:button,manual:false,seen:false,timer:0,hoverTimer:0};states.set(el,s);
      button.addEventListener('click',function(){s.manual=!s.manual;sync(el,s);});
      function interact(){if(paused(el,s)||document.hidden)return;clearTimeout(s.hoverTimer);el.classList.remove('prs1-reveal','prs1-interact');void el.offsetWidth;el.classList.add('prs1-interact');s.hoverTimer=setTimeout(function(){el.classList.remove('prs1-interact');},850);}
      link.addEventListener('pointerenter',function(e){if(e.pointerType!=='touch')interact();});
      link.addEventListener('focus',interact);
      el.dataset.ready='';el.classList.add('prs1-live');sync(el,s);
      if(observer)observer.observe(el);else{el.classList.add('prs1-visible');reveal(el,s);}
    });
  }
  function syncAll(){states.forEach(function(s,el){sync(el,s);});}
  if(reduce.addEventListener)reduce.addEventListener('change',syncAll);else reduce.addListener(syncAll);
  document.addEventListener('visibilitychange',syncAll);
  window.PixelRebelsStampV1={version:'1.0.1',init:init,replay:function(root){init(root);states.forEach(function(s,el){if(!root||root===el||root.contains(el))reveal(el,s);});},pause:function(value){states.forEach(function(s,el){s.manual=Boolean(value);sync(el,s);});}};
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
  document.addEventListener('shopify:section:unload',function(e){states.forEach(function(s,el){if(e.target.contains(el)){if(observer)observer.unobserve(el);clearTimeout(s.timer);clearTimeout(s.hoverTimer);states.delete(el);}});});
  init();if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init();},{once:true});
})();
  } catch(e) { console.error(e); }
})();

})();
